import { IFeasibilityCheck } from 'features/FeasibilityCheck';
import { BriefProps } from 'utils/types';

export const getBadgeType = (badgeText: string, data: any) => {
  switch (badgeText) {
    case data?.[2]: {
      return 'green';
    }
    case data?.[3]: {
      return 'yellow';
    }
    case data?.[5]:
    case data?.[4]: {
      return 'orange';
    }
    default: {
      return 'green';
    }
  }
};

export const getPumpTypeBadgeText = (pumpType: string, data: string[], t: (value: string) => string) => {
  switch (pumpType) {
    case t('other'):
    case t('membrane'): return data[5];
    case t('peristaltic'):
    case t('progressingCavity'): return data[2];
    case t('centrifugal'): return data[3];
    default: return '';
  }
};

export const getPumpTypeText = (pumpType: string, data: string[], t: (value: string) => string) => {
  switch (pumpType) {
    case t('other'): return data[40];
    case t('membrane'): return data[36];
    case t('peristaltic'):
    case t('progressingCavity'): return data[37];
    case t('centrifugal'): return data[39];
    default: return '';
  }
};

export const getProductStirringCombination = (technicalData: IFeasibilityCheck['technical'], t: (value: string) => string) => {
  const stirredTankYes = technicalData.stirredTank?.value === t('yes');
  const stirredTankNo = technicalData.stirredTank?.value === t('no');
  const product_56 = technicalData.product?.value.includes('Neutramaxx');
  const timeDeliveriesTrue = Number(technicalData.timeDeliveries) <= 30;
  const timeDeliveriesFalse = Number(technicalData.timeDeliveries) > 30;
  const productRecirculationYes = technicalData.productRecirculation?.value === t('yes');
  const productRecirculationNo = technicalData.productRecirculation?.value === t('no');

  switch (true) {
    case stirredTankYes && product_56: return '1';
    case stirredTankYes && !product_56: return '2';
    case stirredTankNo && !product_56: return '3';
    case stirredTankNo && product_56 && timeDeliveriesTrue && productRecirculationYes: return '4';
    case stirredTankNo && product_56 && timeDeliveriesTrue && productRecirculationNo: return '5';
    case stirredTankNo && product_56 && timeDeliveriesFalse && productRecirculationYes: return '6';
    case stirredTankNo && product_56 && timeDeliveriesFalse && productRecirculationNo: return '7';
    default: return '';
  }
};

export const getProductStirringBadgeText = (value: string, data: string[]) => {
  switch (value) {
    case '1':
    case '2': return data[2];
    case '3': return data[5];
    case '4':
    case '5':
    case '6':
    case '7': return data[3];
    default: return '';
  }
};

export const getProductRecirculationBadgeText = (value: string, data: string[]) => {
  switch (value) {
    case '1':
    case '2':
    case '3': return '';
    case '4': return data[2];
    case '5': return data[3];
    case '6': return data[2];
    case '7': return data[5];
    default: return '';
  }
};

export const getProductStirringText = (value: string, data: string[]) => {
  switch (value) {
    case '3': return data[49];
    case '5': return data[50];
    case '6':
    case '7':
    case '1':
    case '2':
    case '4':
    default: return '';
  }
};

export const getProductRecirculationText = (value: string, data: string[]) => {
  switch (value) {
    case '5': return data[51];
    case '7': return data[52];
    case '1':
    case '2':
    case '3':
    case '4':
    case '6': return '';
    default: return '';
  }
};

export const getPlantSetupCheck = (plantSetUpData: IFeasibilityCheck['plant'] | null) => {
  if (!plantSetUpData?.processSteps?.length) {
    return false;
  }

  return [plantSetUpData.processSteps?.[7]?.isSptepsCheck, plantSetUpData.processSteps?.[8]?.isSptepsCheck, plantSetUpData.processSteps?.[12]?.isSptepsCheck].some((value) => value);
};

interface IAvdProps {
  brief: BriefProps[];
  product: string;
  industry: string;
  subIndustry: string;
  apps: string;
  t: (value: string) => string;
}

export const getAdvantagesText = ({
  brief,
  product,
  industry,
  subIndustry,
  apps,
  t,
}: IAvdProps) => {
  const advProdust = brief.find((briefProduct) => briefProduct.Industry === industry &&
    (briefProduct['Sub-Industry'] === subIndustry || subIndustry === `${t('noSubSegment')}`) &&
    briefProduct.Application === apps &&
    briefProduct['Product recommendation'] === product,
  );

  if (advProdust) {
    const result = [];

    advProdust['Product benefits1'] && result.push(advProdust['Product benefits1']);
    advProdust['Product benefits2'] && result.push(advProdust['Product benefits2']);
    advProdust['Product benefits3'] && result.push(advProdust['Product benefits3']);
    advProdust['Product benefits4'] && result.push(advProdust['Product benefits4']);
    advProdust['Product benefits5'] && result.push(advProdust['Product benefits5']);
    advProdust['Product benefits6'] && result.push(advProdust['Product benefits6']);
    advProdust['Additional optional benefits'] && result.push(advProdust['Additional optional benefits']);
    advProdust['Additional optional benefits2'] && result.push(advProdust['Additional optional benefits2']);
    advProdust['Additional optional benefits3'] && result.push(advProdust['Additional optional benefits3']);
    advProdust['Additional optional benefits4'] && result.push(advProdust['Additional optional benefits4']);
    advProdust['Additional optional benefits5'] && result.push(advProdust['Additional optional benefits5']);
    advProdust['Additional optional benefits6'] && result.push(advProdust['Additional optional benefits6']);

    return result.slice(0, 6);
  }
};
